const getOrderLineModifiers3 = ({ orderLine, value, index }) => {
  if (value !== null && value !== undefined) {
    return value;
  }
  if (index !== undefined) {
    const indexOrderLine = orderLine ? orderLine[index] : null;
    if (indexOrderLine && indexOrderLine.Modifiers) {
      return typeof indexOrderLine.Modifiers === 'object'
        ? indexOrderLine.Modifiers[2] : indexOrderLine.Modifiers.slice(4, 6);
    }
    return null;
  }
  return orderLine
    ? orderLine.map(item => (typeof item.Modifiers === 'object'
      ? item.Modifiers[2] : item.Modifiers.slice(4, 6)).join(', '))
    : null;
};

export default getOrderLineModifiers3;



// WEBPACK FOOTER //
// ./src/utils/print/getOrderLineModifiers3.js